import { breakpoints } from '../constants/breakpoints';
import { DeviceType } from '../constants/device';

export const getDeviceType = (width: number): DeviceType => {
  switch (true) {
    case width <= breakpoints.values.sm:
      return DeviceType.MOBILE;
    case width > breakpoints.values.sm && width <= breakpoints.values.md:
      return DeviceType.TABLET;
    case width > breakpoints.values.md:
      return DeviceType.DESKTOP;
    default:
      return DeviceType.DESKTOP;
  }
};
